import React from 'react'
import TextField from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@itsrever/design-system'

interface SearchProps {
  freeText: string
  setFreeText: (freeText: string) => void
  label?: string
}

const FilterComponent: React.FC<SearchProps> = ({
  freeText,
  setFreeText,
  label
}) => {
  const { t } = useTranslation()

  const theme = useTheme()

  return (
    <TextField
      data-testid="SearchInput"
      variant="standard"
      InputProps={{
        disableUnderline: true
      }}
      sx={{
        '& .MuiFormLabel-root': {
          top: '-5px'
        },
        '& label.Mui-focused': {
          color: theme.colors.common.black,
          top: '0'
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: theme.colors.primary.dark
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            backgroundColor: 'transparent'
          },
          '&:hover fieldset': {
            borderColor: theme.colors.primary.dark
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.colors.primary.dark,
            backgroundColor: 'transparent'
          }
        }
      }}
      label={
        <p className="text-xs">
          <SearchIcon
            style={{ color: theme.colors.primary.dark }}
            fontSize="small"
          />
          {label ? label : t('search_component.search')}
        </p>
      }
      value={freeText}
      onChange={(e) => setFreeText(e.target.value)}
    />
  )
}

export default FilterComponent
